'use client'

import type { ReactNode } from 'react'
import { LocaleContext } from '@/utilities/LocaleContext'
import type { TypedLocale } from 'payload'
import { seedTranslationResourceCache } from '@/lib/translations'

export default function LocaleProvider({
  locale,
  translations,
  children,
}: {
  locale: TypedLocale
  translations?: Record<string, string>
  children: ReactNode
}) {
  if (translations) {
    seedTranslationResourceCache(locale, translations)
  }

  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
}
